import { Box } from "@mui/material";
import React from "react";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";

const HospitalLocationDetails = () => {
  const { user } = useUserStore();

  return (
    <Box className="my-[1%] w-full text-center cursor-default">
      <Box className="geograph-medium text-sm flex w-full items-center justify-center">
        <img height={15} width={15} src="/assets/icons/locationIcon.svg" />
        <p className="">GoodVets {user?.location?.locationName}</p>
      </Box>
      <p className="geograph-regular text-xs text-center pb-1 mt-1">{user?.location?.address}</p>
    </Box>
  );
};

export default HospitalLocationDetails;
